/**
 * Библиотека фотографий: cloud URL из photo-cloud-urls.json → индустрия в фильтре.
 * Поисковые теги — по 5 на файл, см. photo-search-tags.json
 */

// Порядок чипов в UI
const FOLDER_ORDER = [
  "auto",
  "businessmans",
  "ecom",
  "entertainment",
  "fashion",
  "gadgets",
  "pharma",
  "real_estate",
  "smb",
  "travel",
  "work",
];

const FOLDER_TO_INDUSTRY = {
  auto: "Авто",
  businessmans: "Предприниматели",
  ecom: "Ecom",
  entertainment: "Развлечения",
  fashion: "Fashion",
  gadgets: "Гаджеты",
  pharma: "Фарма",
  real_estate: "Недвижимость",
  smb: "Малый бизнес",
  travel: "Путешествия",
  work: "Работа",
};

const searchTagsByFile = require("./photo-search-tags.json");
const photoCloudUrls = require("./photo-cloud-urls.json");

function folderIndex(folder) {
  const i = FOLDER_ORDER.indexOf(folder);
  return i === -1 ? 99 : i;
}

function fileSortKey(relative) {
  const m = relative.match(/^\.\/([^/]+)\/(.+)$/);
  if (!m) {
    return [99, 0, relative];
  }
  const f = m[1];
  const name = m[2];
  const n = (name.match(/_(\d{5})/) || [0, 0])[1];
  return [folderIndex(f), parseInt(n, 10) || 0, relative];
}

const keys = Object.keys(searchTagsByFile)
  .filter((k) => k.includes("/") && !k.includes("DS_Store"))
  .sort((a, b) => {
    const ka = fileSortKey(a);
    const kb = fileSortKey(b);
    for (let i = 0; i < 3; i += 1) {
      if (ka[i] !== kb[i]) {
        return ka[i] < kb[i] ? -1 : 1;
      }
    }
    return 0;
  });

const images = keys.map((rel) => {
  const m = rel.match(/^([^/]+)\//);
  const folder = m ? m[1] : "";
  const industry = FOLDER_TO_INDUSTRY[folder] || "Работа";
  const cloudUrl = photoCloudUrls.byRelativePath[rel];
  let searchTags = searchTagsByFile[rel];
  if (!searchTags || !Array.isArray(searchTags) || searchTags.length < 5) {
    const fallback = ["снимок", "кампания", "рынок", "сцена", "тема"];
    searchTags = (searchTags || []).concat(fallback).filter(Boolean);
    searchTags = searchTags.slice(0, 5);
  } else {
    searchTags = searchTags.slice(0, 5);
  }

  return {
    file: cloudUrl || "",
    tags: {
      industry: [industry],
    },
    searchTags,
  };
});

const photosIndustryTags = FOLDER_ORDER.map((f) => FOLDER_TO_INDUSTRY[f]);

module.exports = {
  images,
  photosIndustryTags,
  FOLDER_TO_INDUSTRY,
  FOLDER_ORDER,
};
